// Family tab tour steps
import type { TourStep } from './types';

export const FAMILY_TOUR: TourStep[] = [
  {
    target: 'body',
    content: 'Manage birth profiles for your family members - save charts for quick access later.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="family-add"]',
    content: 'Click here to add a new family member profile with their birth details.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="family-list"]',
    content: 'View all saved family member profiles. Click any profile to load their chart.',
    placement: 'right',
  },
  {
    target: '[data-tour="family-quota"]',
    content: 'You can save up to 5 family members by default. Request more quota from Admin if needed.',
    placement: 'left',
  },
];
